import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

const BillingApi = {

    CreateCustomerPortalSessionAsync: async function (): Promise<ProcessingResult<string>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Billing/CreateCustomerPortalSession", {
            method: "Post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: ""
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.url);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default BillingApi;